import type { CSSProperties } from 'react'
import { COLORS, SHADOWS, RADIUS } from '../../styles/tokens'
import StatCard from '../StatCard'

interface StatsPreviewCardProps {
  avgScore:      number | null
  bestActivity:  string | null
  totalSessions: number
  onViewStats:   () => void
  loading:       boolean
  avgScoreLabel: string
  bestLabel:     string
  sessionsLabel: string
  ctaLabel:      string
}

const STAT_META = [
  { key: 'avgScore',      icon: '📊', accentColor: '#52B788' },
  { key: 'bestActivity',  icon: '🏆', accentColor: '#D4A017' },
  { key: 'totalSessions', icon: '🎮', accentColor: '#6B4C3B' },
] as const

export default function StatsPreviewCard({
  avgScore, bestActivity, totalSessions, onViewStats, loading,
  avgScoreLabel, bestLabel, sessionsLabel, ctaLabel,
}: StatsPreviewCardProps) {
  const values: Record<string, string> = {
    avgScore:      avgScore != null ? avgScore.toLocaleString() : '—',
    bestActivity:  bestActivity ?? '—',
    totalSessions: String(totalSessions),
  }
  const labels: Record<string, string> = {
    avgScore:      avgScoreLabel,
    bestActivity:  bestLabel,
    totalSessions: sessionsLabel,
  }

  if (loading) {
    return (
      <div style={s.card}>
        <div style={s.grid}>
          {STAT_META.map(m => (
            <div key={m.key} style={s.skeletonCard} />
          ))}
        </div>
      </div>
    )
  }

  return (
    <div style={s.card}>
      <div style={s.grid}>
        {STAT_META.map(m => (
          <StatCard
            key={m.key}
            icon={m.icon}
            value={values[m.key]}
            label={labels[m.key]}
            accentColor={m.accentColor}
          />
        ))}
      </div>
      <button onClick={onViewStats} style={s.ctaBtn} aria-label={ctaLabel}>
        {ctaLabel}
      </button>
    </div>
  )
}

const s: Record<string, CSSProperties> = {
  card: {
    display:       'flex',
    flexDirection: 'column',
    gap:           12,
  },
  grid: {
    display:             'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap:                 12,
  },
  skeletonCard: {
    height:       110,
    borderRadius: 16,
    background:   '#EFE7D7',
  },
  ctaBtn: {
    display:      'block',
    width:        '100%',
    padding:      '14px 24px',
    background:   COLORS.gradientPrimary,
    color:        '#FFFFFF',
    fontFamily:   'Nunito, sans-serif',
    fontSize:     '1rem',
    fontWeight:   800,
    border:       'none',
    borderRadius: RADIUS.lg,
    cursor:       'pointer',
    minHeight:    52,
    boxShadow:    SHADOWS.button,
  },
}

